const adaptData = ({ meal }) => {
    return {
        meal
    }
};

export default adaptData;
